import React from 'react'
import qs from 'query-string'
import ReView from '@catsync/re-view'
import GetVideoUrl from '../components/GetVideoUrl'
import drill1Data from '../data/prc-drill1.json'
import drill2Data from '../data/prc-drill2.json'
import essentialFormData from '../data/essential-form.json'

const VideoPracticeScreen = ({ navigate, location }) => {
  const params = qs.parse(location.search)
  const [url, setUrl] = React.useState('')

  React.useEffect(() => {
    const drill1Url = 'https://youtu.be/D6yulo1FwUY'
    const drill2Url = 'https://youtu.be/-Io1A_SbQTI'
    const essentialUrl = 'https://youtu.be/ESmo4-vKPsg'
    localStorage[drill1Url] = JSON.stringify(drill1Data)
    localStorage[drill2Url] = JSON.stringify(drill2Data)
    localStorage[essentialUrl] = JSON.stringify(essentialFormData)
  }, [])

  React.useEffect(() => {
    if (url && url !== params.url) {
      const videoParams = qs.stringify({ url })
      navigate(`/video?${videoParams}`)
    }
  }, [navigate, params.url, url])

  return params.url ? (
    <ReView videoUrl={params.url} />
  ) : (
    <GetVideoUrl onSubmit={setUrl} />
  )
}

export default VideoPracticeScreen
